export const ACADEMY_TOPICS = [
  { id: 'getting-started', label: 'Getting started', terms: /onboard|new hire|getting started|orientation|roadmap/i },
  { id: 'marketing', label: 'Marketing & content', terms: /marketing|marketplace|facebook|tiktok|canva|capcut|social media|content creat|video|recruit/i },
  { id: 'conversations', label: 'Conversations & assessment', terms: /conversation|objection|assessment|pitch|qualif|curiosity|follow.?up|lead/i },
  { id: 'appointments', label: 'Appointments & sales', terms: /appointment|sales|selling|closing|deposit|tour/i },
  { id: 'financing', label: 'Financing & land', terms: /financ|lender|mortgage|credit|land|loan|fha|underwriting/i },
  { id: 'contracts', label: 'Contracts & delivery', terms: /contract|document|doc hub|delivery|installation|setup|title|p.l|commission/i },
  { id: 'operations', label: 'Operations & service', terms: /service|inventory|operations|crm|admin|payroll/i },
  { id: 'general', label: 'General training', terms: /$^/ }
];

export function plainText(value) {
  const el = document.createElement('div');
  el.innerHTML = String(value || '');
  return (el.textContent || '').replace(/\s+/g, ' ').trim();
}

export function courseTopic(course) {
  const explicit = ACADEMY_TOPICS.find(t => t.id === course.category);
  if (explicit) return explicit;
  const text = `${course.title || ''} ${plainText(course.description)}`;
  return ACADEMY_TOPICS.find(t => t.terms.test(text)) || ACADEMY_TOPICS[ACADEMY_TOPICS.length - 1];
}

export function courseState(course) {
  const done = course.learning?.completedCount || 0;
  return done && done >= course.lessonCount ? 'completed' : done ? 'progress' : 'new';
}

export function matchingLessons(course, query) {
  const words = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
  return words.length ? (course.outline || []).filter(l => words.every(w => `${l.title} ${l.moduleTitle}`.toLowerCase().includes(w))) : [];
}

export function matchesCourse(course, query) {
  const text = `${course.title} ${plainText(course.description)} ${courseTopic(course).label}`.toLowerCase();
  return query.toLowerCase().trim().split(/\s+/).every(w => text.includes(w)) || matchingLessons(course, query).length > 0;
}
